var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onomatopee",style:([_vm.onomatopeeSize, _vm.bgImgStyle, _vm.computedStyle]),on:{"mousedown":function($event){return _vm.$emit('mousedown', $event)},"touchstart":function($event){return _vm.$emit('touchstart', $event)},"dblclick":function($event){return _vm.$emit('dblclick', $event)}}},[_vm._v("   ")])
}
var staticRenderFns = []

export { render, staticRenderFns }